import {
  PARTNERS,
  PROMOTIONS,
  PROMOTIONS_V2,
  SKINCARE_PARTNERS,
  SKINCARE_PROMOTIONS,
} from 'lib/constants/routes';
import { useRouter } from 'next/router';

export const useIsCampaignPage = () => {
  const router = useRouter();

  return (
    router.route === `${PROMOTIONS}/[slug]` ||
    router.route === `${PROMOTIONS_V2}/[slug]` ||
    router.route === `${PARTNERS}/[slug]` ||
    router.route === `${SKINCARE_PROMOTIONS}/[slug]` ||
    router.route === `${SKINCARE_PARTNERS}/[slug]`
  );
};
